import React, { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Container, Button, Card, Form, Row, Col } from "react-bootstrap";
import AuthHeader from "../../components/header/AuthHeader";
import { FaArrowRight } from "react-icons/fa";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { resetPassword } from "../../redux/actions/AuthUserActions";
import Loader from "../../components/loader/Loader";
import { useDispatch } from "react-redux";
import Swal from "sweetalert2";

function ForgotPasswordEmail() {
  const navigate = useNavigate();
  const location = useLocation();
  const { email } = location.state || {};
  const [submitting, setSubmitting] = useState(false);
  const dispatch = useDispatch();

  const schema = Yup.object({
    otp: Yup.string().required("otp requis"),
    password: Yup.string()
      .min(6, "Le mot de passe doit contenir au moins 6 caractères")
      .required("Mot de passe requis"),
    confirmPassword: Yup.string()
      .oneOf(
        [Yup.ref("password"), null],
        "Les mots de passe doivent correspondre"
      )
      .required("Confirmation du mot de passe requise"),
  });

  const formik = useFormik({
    initialValues: {
      otp: "",
      password: "",
      confirmPassword: "",
      email: email,
    },
    validationSchema: schema,
    onSubmit: (values) => {
      setSubmitting(true);
      dispatch(
        resetPassword(values, (response) => handleCallback(response, values))
      );
    },
  });

  const handleCallback = ({ success, message }) => {
    const Toast = Swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 4000,
    });
    if (success) {
      Toast.fire({
        icon: "success",
        title: "Succès",
        text: message,
      });
      navigate("/login");
    } else {
      Toast.fire({
        icon: "error",
        title: "Échec",
        text: message,
      });
    }
    setSubmitting(false);
  };

  return (
    <>
      <AuthHeader />
      <Loader isLoading={submitting} />
      <Container
        fluid
        style={{
          backgroundColor: "#fff",
          padding: "20px",
          minHeight: "80vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Row
          className="justify-content-center"
          style={{
            width: "100%",
            margin: 0,
          }}
        >
          <Col
            xs={12}
            sm={10}
            md={8}
            lg={6}
            xl={4}
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Card
              style={{
                width: "100%",
                padding: "20px",
                boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
                borderRadius: "18px",
                backgroundColor: "#fff",
              }}
            >
              <Card.Body>
                <h5
                  className="text-center mb-2"
                  style={{
                    color: "#FF5500",
                    fontWeight: "500",
                  }}
                >
                  RÉINITIALISER LE MOT DE PASSE
                </h5>
                <p
                  style={{ color: "#666", marginTop: "5px", fontSize: "14px" }}
                >
                  Un code OTP a été envoyé à votre adresse e-mail et par SMS. Il
                  est valide pendant{" "}
                  <span style={{ color: "#FF5500", fontWeight: "500" }}>
                    30 minutes
                  </span>
                  .
                </p>
                <Form
                  onSubmit={formik.handleSubmit}
                  style={{ textAlign: "left" }}
                >
                  <Form.Group controlId="otp" className="mb-3">
                    <Form.Control
                      type="text"
                      name="otp"
                      placeholder="Code otp"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.otp}
                      isInvalid={formik.touched.otp && formik.errors.otp}
                      style={{
                        height: "45px",
                        borderRadius: "10px",
                      }}
                    />
                    <Form.Control.Feedback type="invalid">
                      {formik.errors.otp}
                    </Form.Control.Feedback>
                  </Form.Group>

                  <Form.Group controlId="password" className="mb-3">
                    <Form.Control
                      type="password"
                      name="password"
                      placeholder="Nouveau mot de passe"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.password}
                      isInvalid={
                        formik.touched.password && formik.errors.password
                      }
                      style={{
                        height: "45px",
                        borderRadius: "10px",
                      }}
                    />
                    <Form.Control.Feedback type="invalid">
                      {formik.errors.password}
                    </Form.Control.Feedback>
                  </Form.Group>

                  <Form.Group controlId="confirmPassword" className="mb-3">
                    <Form.Control
                      type="password"
                      name="confirmPassword"
                      placeholder="Confirmer le mot de passe"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.confirmPassword}
                      isInvalid={
                        formik.touched.confirmPassword &&
                        formik.errors.confirmPassword
                      }
                      style={{
                        height: "45px",
                        borderRadius: "10px",
                      }}
                    />
                    <Form.Control.Feedback type="invalid">
                      {formik.errors.confirmPassword}
                    </Form.Control.Feedback>
                  </Form.Group>

                  <Button
                    type="submit"
                    style={{
                      width: "100%",
                      borderRadius: "10px",
                      backgroundColor: "#051259",
                      color: "#fff",
                      fontWeight: "bold",
                      height: "45px",
                      marginTop: "10px",
                    }}
                    disabled={!formik.isValid}
                  >
                    Continuer
                    <FaArrowRight style={{ marginLeft: "8px" }} />
                  </Button>
                </Form>
              </Card.Body>
              <Card.Footer
                style={{
                  backgroundColor: "#fff",
                  textAlign: "center",
                  fontSize: "14px",
                  marginTop: "10px",
                }}
              >
                <span>
                  <Link
                    onClick={() => navigate(-1)}
                    style={{
                      color: "#051259",
                      textDecoration: "underline",
                    }}
                  >
                    Retour
                  </Link>
                </span>
              </Card.Footer>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default ForgotPasswordEmail;
